<template>
  <div>
    <div
      :disabled="dragged"
      @click.prevent
      class="customer-draggable dragable-no-active"
      style="top: calc(100vh - 200px);"
    >
      <div class="frame card-calendar-list" v-dragged="onDragged">
        <div class="text-center pt-4">
          <div class="draggable-tab m-auto my-2"></div>
        </div>

        <div class="container dragged">
          <div class="input-group mb-4">
            <input
              v-model="searchForm"
              type="text"
              class="form-control fluid-search"
              placeholder="ค้นหา"
              @focus="$emit('eventDragged', false)"
              @keyup.enter="searchCustomer($event)"
            />
            <div class="input-group-prepend">
              <span class="input-group-text icon-search">
                <i class="icon-Search"></i>
              </span>
            </div>
          </div>

          <div class="my-2">
            <span style="color: #003C8F;">
              <img src="/img/icons_v2/bx_info-circle.png" alt="icon-info" />
              กรุณาตรวจสอบ การเปิดใช้บริการตำแหน่งที่ตั้ง (Location) ที่อุปกรณ์ของท่าน
            </span>

            <div>
              <span>
                ** หากตำแหน่งไม่อัพเดต กรุณาทำการ
                <u>เปิด-ปิด ตำแหน่ง (Location)</u>
                อีกครั้ง ณ บริเวณนั้นไม่เกิน 5 Km.
              </span>
            </div>
          </div>

          <div class="scroll-shop mt-3">
            <div
              v-for="(items, index) in customers"
              :key="index"
              class="panel-customer"
              @click="selectCheck(items)"
            >
              <div class="col-1 text-center">
                <img :src="items.customer_pic" class="picture-ctm" />
              </div>
              <div class="col-5 px-6 mt-3">
                <h4 class="textoverflow">{{ items.customer_name }}</h4>
                <small class="textoverflow">{{ items.address }}</small>
              </div>
              <div class="col-3 text-center">
                <base-icon-pin
                  :data-distance="items.distance"
                  :data-unit="items.unit"
                  font-size="25"
                  icon-size="42"
                />
              </div>
              <div class="col-2  text-center">
                <div v-if="items.plan_by != 0">
                  <div class="card-planby">
                    <span>Plan by :</span>
                    <button type="buuton" class="btn-planby">
                      <div class="card-planby-item">
                        <span class="overflow" :class="activeText(items.plan_by)">
                          {{ displayPlanBy(items.plan_by, items.planby_name) }}
                        </span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-1">
                <v-icon class="font-42 ml-4">icon-RIGHT</v-icon>
              </div>
            </div>
          </div>
        </div>

        <DialogConfirmInOut
          :dialog="dialogConfirm"
          :item="customer"
          :status="statusInOut"
          @close="dialogConfirm = false"
          @save="saveCheck"
          :optionOpen="true"
        />

        <DialogActionVisit
          v-if="dialogVisit"
          :dialog="dialogVisit"
          :item="visit"
          @close="dialogVisit = false"
        />
      </div>
    </div>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import DialogConfirmInOut from '@/components/v2/checkinout/DialogConfirmInOut'
import DialogActionVisit from '@/components/v2/checkinout/DialogActionVisit'
export default {
  components: {
    DialogConfirmInOut,
    DialogActionVisit
  },

  props: {
    getCustomers: Array,
    user: Object,
    location: String,
    visit: Object
  },

  emits: ['saveSuccess'],

  computed: {
    customers() {
      return this.getCustomers ? this.getCustomers : []
    },

    statusInOut() {
      return this.visit == null ? true : false
    },

    overlay() {
      return this.location == null ? true : false
    }
  },

  data() {
    return {
      dragged: false,
      dialogConfirm: false,
      dialogVisit: false,
      customer: null,
      searchForm: ``
    }
  },

  methods: {
    selectCheck(item) {
      this.customer = item

      if (this.visit != null) {
        const action = this.visit.customer_id == item.customer_id ? true : false
        if (action) {
          this.dialogConfirm = true
        } else {
          this.dialogVisit = true
        }
      } else {
        this.dialogConfirm = true
      }
    },

    saveCheck(item) {
      this.dialogConfirm = false
      this.$emit('submit')

      const formData = {
        user_id: this.user.id,
        customer_id: item.customer_id,
        lat_lng: this.location
      }

      this.$store.dispatch('checkinout/getCheckInOut', { formData }).then((res) => {
        const status = res.status
        if (status == 200) {
          Swal.fire({
            icon: 'success',
            title: `${res.message}`,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.$emit('saveSuccess')
          })
        } else {
          Swal.fire({
            width: 650,
            icon: 'warning',
            title: `ไม่สารถเช็คอินได้`,
            html: `${res.message}`,
            showConfirmButton: false,
            timer: 3500
          })
        }
      })
    },

    searchCustomer(event) {
      this.$emit('eventDragged', null)
      this.$emit('search', this.searchForm)
      event.target.blur()
    },

    onDragged({ el, deltaX, deltaY, offsetX, offsetY, clientX, clientY, first, last }) {
      const getscrollY = document.body.style.top
      const doc = document.documentElement
      const parent = el.parentElement
      const headerheight = document.querySelector('.bg-navtop-calendar').clientHeight + 40
      let setDeltaY = deltaY

      const t = +window.getComputedStyle(parent)['top'].slice(0, -2) || 0

      if (first) {
        parent.style.transition = ''
        document.body.style.top = -window.scrollY + 'px'
        document.body.style.position = 'fixed'
        document.body.style.width = '100%'

        this.dragged = true
        return
      }

      el.ontouchend = function(event) {
        parent.style.transition = 'all 0.5s ease 0s'
        if (setDeltaY < 0) {
          parent.style.top = headerheight + 'px'
        } else if (setDeltaY > 0) {
          parent.style.top = 'calc(100vh - 450px)'
        }
      }

      el.onmouseup = function(event) {
        parent.style.transition = 'all 0.5s ease 0s'
        if (setDeltaY < 0) {
          parent.style.top = headerheight + 'px'
        } else if (setDeltaY > 0) {
          parent.style.top = 'calc(100vh - 50px)'
        }
      }

      if (last) {
        document.body.style.width = '100%'
        document.body.style.position = ''
        // document.body.style.position = headerheight + 'px';
        document.body.style.top = ''

        window.scrollTo(0, parseInt(getscrollY || '0') * -1)
        this.dragged = false
        return
      }

      const WY = window.innerHeight
      let windowHeightWithPadding = WY - 50

      if (deltaY > 0 && t < windowHeightWithPadding) {
        parent.style.top = t + deltaY + 'px'
      }

      if (deltaY < 0 && t > headerheight) {
        parent.style.top = t + deltaY + 'px'
      }

      // y = 0
      if (setDeltaY == 0) {
        parent.style.transition = 'all 0.5s ease 0s'
        parent.style.top = 750 + 'px'
      }
    },

    activeText(status) {
      if (status == 0) return ''
      else if (status == '1') return 'text-status s1'
      else if (status == '2') return 'text-status s2'
    },

    displayPlanBy(status, name) {
      var data = null
      if (status == '0') {
        data = null
      } else if (status == '1') {
        data = 'SCG'
      } else if (status == '2') {
        data = name
      } else {
        data = null
      }
      return data
    }
  }
}
</script>

<style lang="scss" scoped>
.container.dragged {
  height: 80vh;
  background: white;
}

.scroll-shop {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 75vh;
  max-height: 75vh;
}

.panel-customer {
  display: flex;
  border-bottom: 1px solid #e9e9e9;
  margin: 20px 0px;
  padding-bottom: 10px;
}

.picture-ctm {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.card-planby {
  // display: flex;
  // flex-direction: column;
  // align-items: flex-end;
  // padding-right: 16px;
  // &-item {
  //   white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  // }
}

.btn-planby {
  width: 125px;
  height: 45px;
  padding: 2px 30px;
  border-radius: 4px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-status {
  font-size: 25px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  &.s1 {
    color: #ea0000;
  }

  &.s2 {
    color: #6b6b6b;
  }
}

// ========================================
.card-shop {
  display: flex;
  // justify-content: space-between;
  border-bottom: 1px solid #e9e9e9;
  padding-bottom: 20px;
  margin: 20px 0px;

  & .iamge-shop {
    border-radius: 50%;
    width: 80px;
    height: 80px;
  }
  & .detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0px 20px;
    max-width: 40vh;
    width: 40vh;
  }
  & .pin {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 15vh;

    &.right {
      justify-content: flex-end;
      width: 20vh;
      margin-left: 5px;
    }
  }
}

.fluid-search {
  height: 70px;
  font-size: 25px;
  background-color: #f6f6f6;
  border: none;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.icon-search {
  height: 70px;
  font-size: 25px;
  border: none;
  background-color: #f6f6f6;
  border-top-right-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}

input:focus,
input:active {
  outline: none !important;
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
